module.exports = __webpack_public_path__ + "static/media/JP_VS_EYELASHES04.e4e2a910.jpg";